import { toggleUIAddFolder } from 'app/Explorer/actions';
import showAddFolderInputSelector from 'app/Explorer/selectors/showAddFolderInput';
import { notifyFailure } from 'app/Notifications/actions';
import pageIdSelector from 'app/Page/selectors/id';
import { setRenderingEnv } from 'app/RenderingEnvironment/actions';
import favoriteFoldersSelector from 'app/UserInfo/selectors/favoriteFolders';
import favoritePagesSelector from 'app/UserInfo/selectors/favoritePages';
import { toggleFavoriteContentThunk as toggleFavoriteContent } from 'app/UserInfo/thunks';

import connect from 'utils/store/connect';

import {
  addFolderThunk as addFolder,
  deleteFolderThunk as deleteFolder,
  deletePageThunk as deletePage,
  getFolderThunk as getFolder,
  updateFolderThunk as updateFolder
} from './thunks';
import cwdSelector from './selectors/cwd';
import cwdDetailsSelector from './selectors/cwdDetails';
import cwdSiteRootFolderIdSelector from './selectors/cwdSiteRootFolderId';
import treeSelector from './selectors/tree';
import Tree from './components/Tree';

/**
 * Return object mapping state to prop
 * @param {object} state - Redux state object
 * @returns {object} Object for react props
 */
const mapStateToProps = state => ({
  currentPageId: pageIdSelector(state),
  cwd: cwdSelector(state),
  cwdDetails: cwdDetailsSelector(state),
  cwdSiteRootFolderId: cwdSiteRootFolderIdSelector(state),
  favoriteFolders: favoriteFoldersSelector(state),
  favoritePages: favoritePagesSelector(state),
  tree: treeSelector(state),
  showAddFolderInput: showAddFolderInputSelector(state)
});

const mapDispatchToProps = {
  addFolder,
  deleteFolder,
  deletePage,
  getFolder,
  notifyFailure,
  setRenderingEnv,
  toggleFavoriteContent,
  toggleUIAddFolder,
  updateFolder
};

export default connect(mapStateToProps, mapDispatchToProps)(Tree);
